<template>
    <div class="skillset-container">
      <h1 class="skillset-title">Skillset</h1>
      <p class="skillset-subtitle">A list of my technical skills</p>
  
      <div class="category-filters">
        <button v-for="category in categories" :key="category" :class="{ 'active': activeCategory === category }" @click="setFilter(category)">
          {{ category }}
        </button>
      </div>
  
      <div class="skills-grid">
        <div class="skill-card" v-for="skill in filteredSkills" :key="skill.name">
          <i :class="['skill-icon', skill.iconClass]"></i>
          <div class="skill-details">
            <div class="skill-name">{{ skill.name }}</div>
            <div class="skill-category">{{ Array.isArray(skill.category) ? skill.category.join(', ') : skill.category }}</div>
          </div>
        </div>
      </div>
    </div>
    <footer>
        © 2024 Bakir Hamidovic
    </footer>
  </template>
  
  
  <script>
  import { VueMetaPlugin } from 'vue-meta';
  export default {
    name: "SkillsetPage",
    metaInfo: {
        meta: [
        {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1.0',
        },
        ],
    },
    data() {
      return {
        skills: [
          { name: 'C', category: 'Programming', iconClass: 'devicon-c-plain' },
          { name: 'C++', category: 'Programming', iconClass: 'devicon-cplusplus-plain' },
          { name: 'Java', category: 'Programming', iconClass: 'devicon-java-plain' },
          { name: 'Vue.js', category: 'Web Development', iconClass: 'devicon-vuejs-plain' },
          { name: 'Node.js', category: 'Web Development', iconClass: 'devicon-nodejs-plain' },
          { name: 'Python', category: 'Programming', iconClass: 'devicon-python-plain' },
          { name: 'Express', category: 'Web Development', iconClass: 'devicon-express-original' },
          { name: 'SpringBoot', category: 'Web Development', iconClass: 'devicon-spring-plain' },
          { name: 'Github', category: 'Version Control', iconClass: 'devicon-github-plain' },
          { name: 'Firebase', category: 'Database', iconClass: 'devicon-firebase-plain' },
          { name: 'MariaDB', category: 'Database', iconClass: 'fas fa-database' },
          { name: 'HTML', category: 'Web Development', iconClass: 'devicon-html5-plain' },
          { name: 'CSS', category: 'Web Development', iconClass: 'devicon-css3-plain' },
          { name: 'Linux', category: 'Operating Systems', iconClass: 'devicon-linux-plain' },
          { name: 'Raspberry Pi', category: 'Electronics', iconClass: 'fas fa-microchip' },
          { name: 'Arduino', category: 'Electronics', iconClass: 'fas fa-microchip' },
          { name: 'Microcontrollers', category: 'Electronics', iconClass: 'devicon-arduino-plain' },
          { name: 'Sensors', category: 'Electronics', iconClass: 'fas fa-thermometer-half' },
          { name: 'Bash/zsh', category: 'Shell', iconClass: 'devicon-bash-plain' },
          { name: 'Network Engineering', category: 'Network Engineering', iconClass: 'fas fa-random' },
          { name: 'Network Design and Implementation', category: ['Network Engineering', 'Design'], iconClass: 'fas fa-project-diagram' },
          { name: 'Network Troubleshooting', category: 'Network Engineering', iconClass: 'fas fa-tools' },
        ],
        categories: ["All", "Programming", "Electronics", "Design", "Database", "Network Engineering", "Other"],
        activeCategory: "All",
      };
    },
    computed: {
    filteredSkills() {
        if (this.activeCategory === "All") {
        return this.skills;
        }
        if (this.activeCategory === "Programming") {
        return this.skills.filter(skill =>
            skill.category === "Programming" || skill.category === "Web Development" || skill.category === "Operating Systems" ||
            (Array.isArray(skill.category) && (skill.category.includes("Programming") || skill.category.includes("Web Development") || skill.category.includes("Operating Systems")))
        );
        }
        if (this.activeCategory === "Other") {
        return this.skills.filter(skill => {
            if (Array.isArray(skill.category)) {
            return !skill.category.some(category => this.categories.includes(category) || category === "Web Development");
            } else {
            return !this.categories.includes(skill.category) && skill.category !== "Web Development" && skill.category !== "Operating Systems";
              }
          });
        }
        return this.skills.filter(skill => {
        if (Array.isArray(skill.category)) {
            return skill.category.includes(this.activeCategory);
        } else {
            return skill.category === this.activeCategory;
          }
        });
      },
    },
    methods: {
        setFilter(category) {
        this.activeCategory = category;
        },
    },
  };
  </script>
  
<style scoped>
.skillset-container {
    max-width: 700px;
    margin: 2rem auto;
    text-align: center;
    color: #4a4a4a; 
    font-family: 'Open Sans', sans-serif; 
  }

  .skillset-title {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: #333;
    font-weight: 800;
  }

  .skillset-subtitle {
    font-size: 1.5rem;
    margin-bottom: 2rem;
    color: #666;
  }

  .skills-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    padding: 0 1rem;
  }

  .skill-card {
    display: flex;
    align-items: center;
    padding: 1rem;
    background: #ffffff;
    border-radius: 8px;
    transition: all 0.15s ease;
    text-align: left;
  }

  .skill-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  .skill-icon {
    font-size: 2rem;
    color: #333;
    flex-shrink: 0;
    margin-right: 0.5rem;
  }

  .skill-details {
    display: flex;
    flex-direction: column;
  }

  .skill-name {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
  }

  .skill-category {
    font-size: 0.85rem;
    color: #666;
    margin-top: 0.25rem;
  }

  .category-filters {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 2rem;
  }

  .category-filters button {
    padding: 0.5rem 1rem;
    border: none;
    background-color: #f5f5f5;
    cursor: pointer;
    transition: background-color 0.3s ease;
    color: #333;
    font-size: 0.95rem;
    border-radius: 4px;
    font-weight: 400;
  }

  .category-filters button:hover,
  .category-filters button.active {
    background-color: #007bff;
    transition: background-color 1s ease;
    color: #f5f5f5;
    
    font-weight: 600;
  }

  footer {
  color: #333;
  text-align: center;
  padding: 30px 0;
  width: 100%;
  position: static;
  bottom: 0;
}

@media (max-width: 600px) {
  .skills-grid {
    grid-template-columns: 1fr;
  }

  .skill-name {
    font-size: 1rem;
    font-weight: 600;
    color: #333;
  }

  .skill-category {
    font-size: 0.8rem;
    color: #666;
    margin-top: 0.25rem;
  }

  .category-filters button {
    font-size: 0.8rem;
  }
}

@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
@import url('https://cdn.jsdelivr.net/npm/devicon@2.14.0/devicon.min.css');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&display=swap');
</style>

  